<template>
  <div class="standardsContents hideScrollbar">
    <div
      v-for="(item,index) in standardsContents.slice(1)"
      :key="index"
    >
      <div :id="item.clause_code">
        <div
          v-if="item.clause_title"
          class="title"
        >{{item.clause_title}}</div>
        <div
          v-else
          class="contents"
          v-html="$options.filters.addTextIndent(item.clause_contents,item.clause_code,item.clause_code2)"
        >
        </div>
        <div
          v-if="item.clause_table"
          v-html="item.clause_table"
        ></div>
        <div
          v-if="item.clause_table2"
          class="dev"
        >
          <table
            border="1"
            width=100%
            class="table"
            cellpadding="5"
          >
            <tr
              v-for="(item,index) in JSON.parse(item.clause_table2).children"
              :key="'d' + index"
            >
              <template v-for="(value,key,index) in item">
                <td
                  :key="'d_d'+index"
                  v-html='value.value'
                  :rowspan="value.rowspan != -1 ? value.rowspan : ''"
                  :colspan="value.colspan != -1 ? value.colspan : ''"
                  v-if="value.rowspan != '-1' && value.colspan != '-1'"
                  :class="value.head ? 'head' : ''"
                >
                </td>
              </template>
            </tr>
          </table>
        </div>
        <div v-if="item.clause_image">
          <div
            v-for="(itm,idx) in item.clause_image.split(',')"
            :key="idx"
            align="center"
          >
            <img
              :src="'static/images/' + itm"
              type="image/svg+xml"
              class="image"
              :id="itm.substring(0,itm.length-4)"
              @click="showImage(itm.substring(0,itm.length-4))"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/misc/bus.js";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import { count } from "@/misc/util.js";
export default {
  props: {
    standardsContents: Array
  },
  mounted() {
    Bus.$on("code", e => {
      this.$nextTick(() => {
        document.getElementById(e).scrollIntoView();
      });
    });
  },
  methods: {
    showImage(id) {
      const viewer = new Viewer(document.getElementById(id), {
        viewed() {
          viewer.zoomTo(1);
        }
      });
    }
  },
  filters: {
    // par: 默认传过来的item.clause_contents
    addTextIndent(p1, p2, p3) {
      // 如果不是国际标准（ISO或IEC），则首行缩进
      var reg = /^I/;
      // 按级别增加缩进
      var n = Math.max(count("-", p2) - count("-", p3) - 2, 0);
      if (reg.test(p2) == true) {
        return "<div style='margin-left:" + 0.2 * n + "rem'>" + p1 + "</div>";
      } else {
        return (
          "<div style='text-indent:0.2rem;margin-left:" +
          0.2 * n +
          "rem'>" +
          p1 +
          "</div>"
        );
      }
    }
  }
};
</script>

<style scoped>
.standardsContents {
  margin-top: 0.2rem;
  height: calc(100vh - 1.4rem);
}

.standardsContents .title {
  margin-top: 0.2rem;
  font-weight: 900;
}

.standardsContents .contents {
  margin-top: 0.1rem;
}

.image {
  padding-top: 0.1rem;
  margin: 0 auto;
  width: 100%;
  max-width: 6rem;
  text-align: center;
}

.dev {
    margin: 0.1rem;
    /* text-align: center; */
}

.table {
    border-collapse: collapse;
}

.table .head {
    font-weight: 900;
    text-align: center
}
</style>